var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassBottle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "106px",
    viewBox: "0 0 43 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glass_bottle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_proc_overview",
    transform: "translate(-659.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy",
    transform: "translate(659.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glass_bottle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b1-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4518382,9.9684397 C34.5323549,14.9267382 35.8947967,20.9686137 38.5391635,28.094066 C41.4298914,35.8833574 42.6026667,59.1012518 42.0574894,97.7477491 C42.0357451,99.2891562 41.3042022,100.734357 40.0748734,101.664496 C36.5394234,104.339526 30.362265,105.67704 21.5433981,105.67704 C12.9102786,105.67704 6.95202828,104.477767 3.668647,102.07922 C2.45937957,101.195836 1.70974259,99.8169322 1.62589645,98.3217185 C-0.399882547,62.1978294 0.285135302,39.2320006 3.68095,29.4242323 C6.7126414,20.6681223 8.57870273,14.1828581 9.27913397,9.9684397 L7.38904991,9.9684397 L7.38904991,5.67704003 L36.7988197,5.67704003 L36.7988197,9.9684397 L34.4518382,9.9684397 Z",
    id: "Combined-Shape",
    fillOpacity: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18724488,0.677040033 L35.1872449,0.677040033 C36.8440991,0.677040033 38.1872449,2.02018578 38.1872449,3.67704003 L38.1872449,7.67704003 L5.18724488,7.67704003 L5.18724488,3.67704003 C5.18724488,2.02018578 6.53039063,0.677040033 8.18724488,0.677040033 Z",
    id: "Rectangle-8",
    fill: "#3A3A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4775391,1.12468999 C17.9729818,1.12468999 22.0159505,1.12468999 23.6064453,1.12468999 C21.0751953,10.0319165 20.7705078,12.0906009 18.7491481,21.4948559 C17.926555,25.321921 15.5264534,36.8180772 14.6264731,52.8096145 C14.1096136,61.9935698 14.5248615,79.5572538 15.872217,105.500667 C13.5494838,105.500667 9.85835422,104.537776 4.79882813,102.611995 C2.86697387,89.9078931 2.86697387,80.6637525 2.86697387,54.9895484 C2.86697387,37.3575904 8.73738578,25.200365 11.2376995,12.0906009 C11.7148604,9.58872827 11.7948069,5.93342464 11.4775391,1.12468999 Z",
    id: "Rectangle-9",
    fillOpacity: 0.253736413,
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassBottle);
export default __webpack_public_path__ + "static/media/glass-bottle.aad1ea8b9742940728a2a0475d333792.svg";
export { ForwardRef as ReactComponent };